import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './BlogHeader.css';

const BlogHeader = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();

  // Helper function to get header button text based on screen size
  const getHeaderButtonText = () => {
    const isMobile = window.innerWidth <= 768;
    const isAuthenticatedAndApproved = isAuthenticated && user?.early_access_approved;
    
    if (isAuthenticatedAndApproved) {
      return 'Go to Build';
    } else if (isMobile) {
      return 'Request EA';
    } else {
      return 'Request Early Access';
    }
  };

  const handleRequestEarlyAccess = () => {
    if (isAuthenticated) {
      if (user?.early_access_approved) {
        navigate('/build');
      } else {
        navigate('/early-access');
      }
    } else {
      const isDevelopment = window.location.hostname === 'localhost';
      const oauthUrl = isDevelopment ? 'https://localhost:5001/auth/google?early_access=true' : '/auth/google?early_access=true';
      window.location.href = oauthUrl;
    }
  };

  const handleViewMarketplace = () => {
    navigate('/talkto');
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <header className="blog-header">
      <div className="container">
        <div className="header-content">
          <div className="logo" onClick={handleLogoClick}>
            <img 
              src={process.env.PUBLIC_URL + "/brain-logo.png"} 
              alt="AgentYou Logo" 
              width={32} 
              height={32}
              style={{ objectFit: 'contain' }}
            />
            <span>AgentYou</span>
          </div>
          <nav className="nav-links">
            <a href="/#features">Features</a>
            <a href="/#marketplace">Marketplace</a>
            <a href="/#how-it-works">How It Works</a>
            <a href="/blog" className="active">Blog</a>
          </nav>
          <div className="header-cta">
            <button className="btn-secondary" onClick={handleViewMarketplace}>
              Browse Agents
            </button>
            <button 
              className="btn-primary" 
              style={{ fontSize: !isAuthenticated || !user?.early_access_approved ? '0.7rem' : '1rem' }}
              onClick={handleRequestEarlyAccess}
            >
              {getHeaderButtonText()}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default BlogHeader;
